import { LevelThreshold } from '@vae/server/src/services/achievementService/types/levelThreshold'
import { ScriptableContext } from 'chart.js'
import clamp from '../math/clamp'
import normalizeNumber from '../math/normalizeNumber'

const getBorderColor = (ctx: ScriptableContext<'line'>, levelThreshold: LevelThreshold) => {
	const { chart } = ctx
	const { ctx: canvas, chartArea } = chart

	if (!chartArea) return '#afafaf'

	const yScale = chart.scales.y

	const { min, max } = yScale.getMinMax(true)

	const minPixel = yScale.getPixelForValue(min)
	const maxPixel = yScale.getPixelForValue(max)

	const gold = levelThreshold.gold
	const platinum = levelThreshold.platinum

	const stop = (v: number) => clamp(normalizeNumber(v, min, max))

	const gradient = canvas.createLinearGradient(0, minPixel, 0, maxPixel)

	gradient.addColorStop(0, '#afafaf')
	gradient.addColorStop(stop(gold - 50), '#afafaf')

	if (max >= gold + 25) {
		gradient.addColorStop(stop(gold + 25), '#ffb30d')
		if (max >= platinum - 50) {
			gradient.addColorStop(stop(platinum - 50), '#ffb30d')
			if (max >= platinum + 25) {
				gradient.addColorStop(stop(platinum + 25), '#d9d9d9')
				gradient.addColorStop(1, '#d9d9d9')
			} else {
				gradient.addColorStop(1, '#ffb30d')
			}
		} else {
			gradient.addColorStop(1, '#ffb30d')
		}
	} else {
		gradient.addColorStop(1, '#afafaf')
	}

	return gradient
}

export default getBorderColor
